import { render, staticRenderFns } from "./df-header.vue?vue&type=template&id=08327d49"
import script from "./df-header.ts?vue&type=script&lang=js&external"
export * from "./df-header.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports